"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default,
    Tinymce: _Tinymce.default
  },
  data: function data() {
    return {
      form: {},
      fileList: [],
      rules: {
        avatar: [{
          required: true,
          message: '请上传小程序logo',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/get_partner_config').then(function (res) {
        _this.form = res;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var url = 'agentapi/system/save_platform_info',
        params = JSON.parse(JSON.stringify(this.form));
      // 【操作埋点】2026-05-25 pc_setting_update_1 平台基本信息
      this.$post(url, params).then(function (res) {
        _this2.$settingReport.reportSettingUpdate('save_platform_info', '平台基本信息', null, params);
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    }
  }
};